import {
  type GetAllFundSourcesRequest,
  GetAllFundSourcesResponse,
  type GetFundSourceFiltersRequest,
  GetFundSourceFiltersResponse,
  type SetFundSourceFiltersRequest,
  SetFundSourceFiltersResponse,
} from "schema/gen/es/chiikipoint/adminconsole/v2/service_pb";
import { FundSource, FundSourceFilter } from "schema/gen/es/chiikipoint/model/v2/model_pb";

import { simulateDelay } from "./utils";

const fundSourceFilters = new Map<
  string,
  { availableCities: string[]; availableStoreIds: string[] }
>();

export const mockGetAllFundSources = async (
  _req: GetAllFundSourcesRequest,
): Promise<GetAllFundSourcesResponse> => {
  await simulateDelay();
  const fundSources: FundSource[] = [
    new FundSource({
      id: "fund_001",
      name: "市民生活支援基金",
      type: "Distributable",
    }),
    new FundSource({
      id: "fund_002",
      name: "地域振興基金",
      type: "Distributable",
    }),
    new FundSource({
      id: "fund_003",
      name: "災害復興支援基金",
      type: "StandaloneDistributable",
    }),
    new FundSource({
      id: "fund_004",
      name: "教育振興基金",
      type: "StandaloneDistributable",
    }),
  ];

  return new GetAllFundSourcesResponse({
    fundSources,
  });
};

export const mockGetFundSourceFilters = async (
  req: GetFundSourceFiltersRequest,
): Promise<GetFundSourceFiltersResponse> => {
  await simulateDelay();
  const fundSourceId = req.query?.fundSourceId ?? "";
  const stored = fundSourceFilters.get(fundSourceId);
  const filters: FundSourceFilter[] = [];

  stored?.availableCities.forEach((city, index) => {
    filters.push(new FundSourceFilter({
      id: `${fundSourceId}-city-${index}`,
      fundSourceId,
      availableCity: city,
    }));
  });

  stored?.availableStoreIds.forEach((storeId, index) => {
    filters.push(new FundSourceFilter({
      id: `${fundSourceId}-store-${index}`,
      fundSourceId,
      availableStoreId: storeId,
    }));
  });

  return new GetFundSourceFiltersResponse({
    filters,
  });
};

export const mockSetFundSourceFilters = async (
  req: SetFundSourceFiltersRequest,
): Promise<SetFundSourceFiltersResponse> => {
  await simulateDelay();
  fundSourceFilters.set(req.fundSourceId, {
    availableCities: [...req.availableCities],
    availableStoreIds: [...req.availableStoreIds],
  });
  return new SetFundSourceFiltersResponse({});
};
